/* eslint-disable no-restricted-syntax */
import { api } from "src/utils/api";

const getOperators = () => api.get('/operator/', {
    params: {
    },
});

const list = async params => {
    const result = await api.get("/request-operator", {
        params
    });

    return result;
};

const text = async (id, text) => {
    const result = await api.post(`/request-operator/create-interaction/${id}`, { text })
    return result;
};
const finishRequest = async (id) => {
    const result = await api.post(`/request-operator/finish-request/${id}`, { text })
    return result;
};

const upload = async (id, files) => {
    const formData = new FormData();

    for(const file of files) {
        formData.append('files[]', file);
    }

    const result = await api.post(`/request-operator/upload/${id}`, formData);
    return result;
};

const loadRequest = id => api.get(`/request-operator/${id}`);

export { getOperators, list, loadRequest, text, finishRequest, upload };
